<template>
  <el-container>
    <el-main>
      <el-form :model="add_info" label-width="9rem">
        <el-form-item label="乐器" required>
          <el-select
            v-model="drum"
            placeholder="请选择乐器"
            @change="selectDrum"
            clearable
          >
            <el-option
              v-for="item in drumList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="曲册" required>
          <el-select
            v-model="album"
            placeholder="请选择曲册"
            @change="selectAlbum"
            clearable
          >
            <el-option
              v-for="item in albumList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="章节" required>
          <el-select
            v-model="add_info.cid"
            placeholder="请选择章节"
            @change="selectChapter"
            clearable
          >
            <el-option
              v-for="item in chapterList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input v-model="add_info.title" maxlength="80"></el-input>
        </el-form-item>
        <el-form-item label="描述" required>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            maxlength="200"
            v-model="add_info.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="是否为考级示范" required>
          <el-radio-group v-model="add_info.isFree">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="视频封面" class="video-container">
          <!--                    <input type="file" class="imgUpload" @change="coverChange($event)">-->
          <input
            type="file"
            class="imgUpload"
            @change="coverChange($event)"
            :disabled="!(add_info.title && add_info.cid)"
          />
          <p>仅支持PNG、JPG图片文件</p>
          <p>图片长：宽=3：2展示效果最佳</p>
          <p>为节约资源请将图片压缩在500KB以下</p>
          <el-button
            @click.stop="coverImgUpload"
            :disabled="startCoverUploadFlag"
            type="primary"
            size="small"
          >
            开始上传
          </el-button>
          <!--本地预览-->
          <img
            v-if="localCoverImgUrl"
            :src="localCoverImgUrl"
            alt=""
            class="cover-img"
          />
        </el-form-item>
        <el-form-item label="曲谱图" class="video-container">
          <input
            type="file"
            class="imgUpload"
            @change="imgChange($event)"
            :disabled="!(add_info.title && add_info.cid)"
          />
          <p>仅支持PNG、JPG图片文件</p>
          <p>为节约资源请将图片压缩在500KB以下</p>
          <el-button
            @click.stop="addImgUpload"
            :disabled="startImgUploadFlag"
            type="primary"
            size="small"
          >
            开始上传
          </el-button>
          <!--本地预览-->
          <img v-if="localImgUrl" :src="localImgUrl" alt="" class="local-img" />
        </el-form-item>
        <el-form-item class="submit-btn">
          <el-button type="primary" @click="saveContent"
            >下一步添加视频</el-button
          >
        </el-form-item>
      </el-form>
      <el-dialog
        title="视频上传"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        width="30%"
        :before-close="handleClose"
      >
        <!-- <div class="video-upload-con">
          <div>
            <el-form ref="form" :model="add_info" label-width="5rem">
              <el-form-item label="曲速" required>
                <el-input v-model="add_info.speed" style="width: 10rem !important;"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <input type="file" id="fileUpload" @change="fileChange($event)" />
            <p>仅支持MP4视频文件(上传停止可再次点击按钮续传)</p>
          </div>
          <div>
            <el-button
              class="video-upload"
              @click="addUpload"
              :disabled="startUploadFlag"
              type="primary"
              size="small">开始上传</el-button>
            <span class="progress">上传进度: <i id="auth-progress">{{ authProgress }}</i> %</span>
          </div>
        </div> -->
        <add-videos ref="addVideos" :course-info="add_info" @change="(o) => {uploading = o}" @end="uploadEnd"></add-videos>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-loading="uploading" @click="uploadStart">开始上传</el-button>
          <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import AddVideos from "./AddVideos.vue"
export default {
  name: "AddContent",
  props: ["contentEditFlag"],
  components: { AddVideos },
  data() {
    return {
      // 保存的信息
      add_info: {
        cid: null,
        title: "", // 标题
        description: "", // 描述
        imageId: "", // 上传成功返回
        videoId: "", // 上传成功返回
        coverUrl: "", // 视频封面
        isFree: 0, // 是否为考级示范 默认为0-非示范，可选值1-示范
      },
      //乐器选择结果
      drum: "",
      //曲册选择结果
      album: "",
      //当前选中的章节id  也是保存内容时的id编号
      currentChapterId: "",
      //乐器列表
      drumList: [],
      // 曲册  列表
      albumList: [],
      //章节列表
      chapterList: [],
      // 视频上传 ---------------------------------
      // 视频上传对象
      auth_uploader: "",
      // 上传视频文件对象
      auth_file: null,
      // 开始上传按钮控制
      startUploadFlag: true,
      //视频上传的进度，
      authProgress: 0,
      // 视频上传凭证返回结果
      authResult: "",
      // 播放按钮控制  成功就会打开  可以用来判断视频是否上传
      playFlag: false,
      //播放按钮可点击控制
      playBtnDisable: true,
      // 可播放计数
      playCount: false,
      // 计数控制
      usePlay: false,
      // 播放容器控制  获取播放凭证成功就会显示
      videoFlag: false,
      // 添加视频弹框显示
      dialogVisible: false,
      // 图片上传 --------------------------------
      img_uploader: "",
      cover_uploader: "",
      // 上传文件对象
      img_file: null,
      cover_file: null,
      // 图片上传按钮控制  先上传视频才能上传封面
      startImgUploadFlag: true,
      startCoverUploadFlag: true,
      // 图片上传的进度，
      imgProgress: 0,
      coverProgress: 0,
      // 图片凭证返回结果
      imgResult: "",
      coverResult: "",
      // 本地路径
      localImgUrl: "",
      localCoverImgUrl: "",
      // 保存的内容编号  和上传时提交
      contentId: "",
      uploading: false, // 视频上传状态
    };
  },
  created() {
    //  获取类目信息（默认是乐器）
    this.getData(0, 0);
  },
  methods: {
    // 获取类目列表
    getData(id, flag) {
      let params = {
        // 默认pid 为0  获取的是乐器列表  获取曲册信息pid为乐器的id
        pid: id ? id : 0,
      };
      let res = this.$api.get("/category/list.json", params);
      res
        .then(
          (success) => {
            if (success.code === 200) {
              if (flag === 0) {
                this.drumList = success.data.reverse();
                console.log(this.drumList);
              } else if (flag === 1) {
                // 曲册
                this.albumList = success.data;
              } else {
                //章节
                this.chapterList = success.data;
              }
            }
          },
          (error) => {
            this.$message.error(error.msg);
          }
        )
        .catch((err) => {
          this.$message.error("请求异常！");
        });
    },

    //选择乐器
    selectDrum(val) {
      //  获取该乐器的曲册内容
      this.getData(val, 1);
    },

    //选择曲册
    selectAlbum(val) {
      //  获取该乐器的曲册内容
      this.getData(val, 2);
    },

    // 选择章节
    selectChapter(val) {
      //保存当前选择的章节编号
      this.currentChapterId = val;
    },

    // 保存数据
    saveContent() {
      this.add_info.imageId = this.imgResult.imageId;
      // 非空校验
      if (!this.add_info.cid) {
        return this.$message.error("请选择章节！");
      }
      if (!this.add_info.imageId) {
        return this.$message.error("请上传曲谱！");
      }
      if (!this.add_info.description) {
        return this.$message.error("内容描述不能为空！");
      }

      let res = this.$api.post("/content/add.json", this.add_info);
      res.then((success) => {
          // 返回视频编号
          this.contentId = success.data;
          this.$set(this.add_info, "parentResourceId", success.data);
          this.dialogVisible = true;
        }, (error) => {
          this.$message.error(error.msg);
        }
      ).catch((err) => {
        this.$message.error("内容生成异常，无法添加视频！");
      });
    },

    // 提交上传
    submitUpload() {
      this.addUpload();
    },

    // 移除文件
    handleRemove(file) {
      console.log(file);
    },

    //弹框关闭
    handleClose() {
      this.dialogVisible = false;
    },

    //视频上传开始--------------------------------------

    //视频文件变换时触发  添加移除都会触发
    fileChange(file) {
      // 文件变换时 上传按钮禁用  类型正确再打开
      this.startUploadFlag = true;

      // 关闭播放容器
      this.playFlag = false;
      // 关闭视频容器
      this.videoFlag = false;
      //  关闭计数
      this.usePlay = false;
      // 按钮不可点击
      this.playBtnDisable = true;

      this.auth_file = file.target.files[0];
      if (!this.auth_file) {
        return this.$message.error("请先选择需要上传的文件!");
      }
      //

      let userData = '{"Vod":{}}';

      if (this.auth_uploader) {
        // 停止上传toLowerCase
        this.auth_uploader.stopUpload();
        // 进度置零
        this.authProgress = 0;
      }
      // console.log('jhsdkajshdkasjh');
      //创建对象
      this.auth_uploader = this.getUpload();
      // 添加文件
      this.auth_uploader.addFile(this.auth_file, null, null, null, userData);
    },

    // 获取upload对象  声明一个AliyunUpload.Vod初始化回调
    getUpload() {
      let that = this;
      let uploader = new AliyunUpload.Vod({
        //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: "1689030746142927",
        region: "cn-shanghai",
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        //是否上报上传日志到点播，默认为true
        enableUploadProgress: true,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log("视频添加成功: " + uploadInfo.file.type);

          if (uploadInfo.file.type === "video/mp4") {
            // 开启文件上传
            that.startUploadFlag = false;
          } else {
            return that.$message.error("仅支持MP4视频文件");
          }
        },

        // 开始上传
        onUploadstarted: function (uploadInfo) {
          console.log("开始上传: " + uploadInfo.file.name);

          let fileExt = uploadInfo.file.name.split(".");
          fileExt = fileExt[fileExt.length - 1];
          if (uploadInfo.videoId) {
            console.log("断点续传------------------------------");
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api
              .get("/content/upload/video/auth/refresh.json", {
                videoId: uploadInfo.videoId,
              })
              .then(
                (success) => {
                  // 保存结果
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  // let videoId = success.data.videoId;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress
                  );
                },
                (error) => {
                  // 刷新不到凭证就重新获取
                  let params = {
                    // 在文件变动的时候这些字段有值
                    cid: that.add_info.cid,
                    title: that.add_info.title,
                    fileExt: fileExt,
                  };
                  that.$api
                    .get("/content/upload/video/auth.json", params)
                    .then(
                      (success) => {
                        // 保存结果
                        that.authResult = success.data;
                        //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                        let uploadAuth = success.data.uploadAuth;
                        let videoId = success.data.videoId;
                        let uploadAddress = success.data.uploadAddress;
                        uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId
                        );
                      },
                      (error) => {
                        that.$message.error(error.msg);
                      }
                    )
                    .catch((err) => {
                      console.log(err);
                      that.$message.error("凭证获取异常！");
                    });
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          } else {
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口
            let params = {
              // 在文件变动的时候这些字段有值
              cid: that.add_info.cid,
              title: that.add_info.title,
              fileExt: fileExt,
            };
            that.$api
              .get("/content/upload/video/auth.json", params)
              .then(
                (success) => {
                  // 保存结果
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  let videoId = success.data.videoId;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress,
                    videoId
                  );
                },
                (error) => {
                  that.$message.error(error.msg);
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          }
        },

        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // that.$message({
          //     message: '上传成功!',
          //     type: 'success'
          // });
          // 把文件对象置空  上传对象置空
          that.auth_uploader = null;
          that.auth_file = null;

          // 显示播放按钮
          that.playFlag = true;
          that.isCanPlay();
          let param = {
            id: that.contentId,
            videoId: that.authResult.videoId,
          };
          console.log(param);
          let res = that.$api.post("/content/video/update.json", param);
          res
            .then(
              (success) => {
                // 保存结果
                that.$message({
                  message: "内容添加成功！",
                  type: "success",
                });
                // 重置
                that.dialogVisible = false;
                that.add_info.cid = null;
                that.add_info.title = "";
                that.add_info.description = "";
                that.add_info.isFree = 0;
                that.add_info.imageId = "";
                that.add_info.videoId = "";
                that.add_info.coverUrl = "";
                that.playFlag = false;
                that.localImgUrl = "";
                that.localCoverImgUrl = "";
                that.startUploadFlag = true;
                that.startImgUploadFlag = true;
                that.startCoverUploadFlag = true;
                that.playBtnDisable = true;
                that.videoFlag = false;
              },
              (error) => {
                that.$message.error(error.msg);
              }
            )
            .catch((err) => {
              console.log(err);
              that.$message.error("视频已上传，但绑定内容异常！");
            });

          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log(
            "上传失败:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
          if (uploadInfo.videoId) {
            console.log("上传失败断点续传------------------------------");
            console.log(uploadInfo.videoId);
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api
              .get("/content/upload/video/auth/refresh.json", {
                videoId: uploadInfo.videoId,
              })
              .then(
                (success) => {
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress
                  );
                },
                (error) => {
                  // that.$message.error(error.msg)
                  // 刷新不到凭证就重新获取
                  let fileExt = uploadInfo.file.name.split(".");
                  fileExt = fileExt[fileExt.length - 1];
                  let params = {
                    // 在文件变动的时候这些字段有值
                    cid: that.add_info.cid,
                    title: that.add_info.title,
                    fileExt: fileExt,
                  };
                  that.$api
                    .get("/content/upload/video/auth.json", params)
                    .then(
                      (success) => {
                        // 保存结果
                        that.authResult = success.data;
                        //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                        let uploadAuth = success.data.uploadAuth;
                        let videoId = success.data.videoId;
                        let uploadAddress = success.data.uploadAddress;
                        uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId
                        );
                      },
                      (error) => {
                        that.$message.error(error.msg);
                      }
                    )
                    .catch((err) => {
                      console.log(err);
                      that.$message.error("凭证获取异常！");
                    });
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          }
        },
        // 文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          let authProgress = Math.ceil(loadedPercent * 100);
          that.authProgress = authProgress;
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          //实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
          let params = {
            videoId: uploadInfo.videoId,
          };
          let res = that.$api.get(
            "/content/upload/video/auth/refresh.json",
            params
          );
          res
            .then(
              (success) => {
                // 保存结果
                that.authResult = success.data;
                //从点播服务刷新的uploadAuth,设置到SDK里
                let uploadAuth = success.data.uploadAuth;
                uploader.resumeUploadWithAuth(uploadAuth);
              },
              (error) => {
                that.$message.error(error.msg);
              }
            )
            .catch((err) => {
              that.$message.error("凭证获取异常！");
            });
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("上传完成！");
        },
      });
      return uploader;
    },
    // 视频播放倒计时   因为刚上传好还不能播放  大概等十五秒
    isCanPlay() {
      // 显示计数
      this.usePlay = true;
      this.playCount = 20;
      let timeInterval = setInterval(() => {
        this.playCount--;
        if (!this.playCount) {
          clearInterval(timeInterval);
          //  关闭计数
          this.usePlay = false;
          // 按钮可点击
          this.playBtnDisable = false;
        }
      }, 1000);
    },

    // 视频点击上传
    addUpload() {
      // if (!this.add_info.cid) {
      //     return this.$message.error("请先选择章节！");
      // }
      if (!this.auth_file) {
        return this.$message.error("请先选择文件！");
      }
      // 上传对象存在调用 startUpload 方法, 开始上传
      if (this.auth_uploader !== null) {
        this.$set(this.add_info, "parentResourceId", this.contentId)
        let res = this.$api.post("/content/add.json", this.add_info);
        res.then((success) => {
              // 返回视频编号
              this.contentId = success.data;
              console.log("this.contentId", this.contentId);
              console.log("this.add_info", this.add_info);
              this.auth_uploader.startUpload();
            }, (error) => {
              this.$message.error(error.msg);
            }
          ).catch((err) => {
            this.$message.error("内容生成异常，无法添加视频！");
          });
      }
    },

    // 获取播放凭证
    getAuth() {
      // this.authResult.videoId
      this.$api.get("/content/video/play/auth.json", {
          videoId: this.authResult.videoId,
        }).then((success) => {
            /**
              coverURL (string, optional),
              duration (number, optional),
              status (string, optional),
              title (string, optional),
              videoId (string, optional)
            */
            // 打开视频容器
            this.videoFlag = true;
            // 获取成功  播放视频  id 封面  凭证
            this.play(
              success.data.videoMeta.videoId,
              success.data.playAuth,
              success.data.videoMeta.coverURL
            );
          },
          (error) => {
            this.$message.error(error.msg);
          }
        ).catch((error) => {
          console.log(error);
          this.$message.error("播放凭证获取异常！");
        });
    },
    // 视频播放
    play(vid, playauth, cover) {
      // console.log(vid);
      // console.log(playauth);
      let player = new Aliplayer(
        {
          id: "J_prismPlayer",
          width: "100%",
          autoplay: false, // 自动播放

          //播放方式二：点播用户推荐
          vid: vid,
          playauth: playauth,
          cover: cover,
          // encryptType:1, //当播放私有加密流时需要设置。
        },
        function (player) {
          console.log("播放器创建好了。");
        }
      );
    },
    // 视频上传结束---------------------------------------

    // 图片上传开始-------------------------------------

    // 选择图片文件
    imgChange(file) {
      // 每次选择图片  恢复上传状态
      this.startImgUploadFlag = true;
      // 取消预览
      this.localImgUrl = "";
      this.img_file = file.target.files[0];
      if (!this.img_file) {
        return this.$message.error("请先选择需要上传的图片文件!");
      }
      // 本地预览
      let imgUrl = this.tools.getObjectURL(this.img_file);
      if (imgUrl) {
        this.localImgUrl = imgUrl;
      }
      // console.log(this.img_file.type);
      let userData = '{"Vod":{}}';
      if (this.img_uploader) {
        // 停止上传
        this.img_uploader.stopUpload();
        // 进度置零
        this.imgProgress = 0;
      }
      //创建对象
      this.img_uploader = this.getImgUpload();
      // 添加文件
      this.img_uploader.addFile(this.img_file, null, null, null, userData);
    },
    coverChange(file) {
      this.startCoverUploadFlag = true;
      // 取消预览
      this.localCoverImgUrl = "";
      this.cover_file = file.target.files[0];
      if (!this.cover_file) {
        return this.$message.error("请选择需要上传的视频封面!");
      }
      // 选择图片可以上传
      this.startCoverUploadFlag = false;
      // 本地预览
      let imgUrl = this.tools.getObjectURL(this.cover_file);
      if (imgUrl) {
        this.localCoverImgUrl = imgUrl;
      }
    },
    // 获取上传对象
    getImgUpload() {
      let that = this;
      let img_uploader = new AliyunUpload.Vod({
        //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: "1689030746142927",
        region: "cn-shanghai",
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        //是否上报上传日志到点播，默认为true
        enableUploadProgress: true,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log("图片添加成功startImgUploadFlag: " + uploadInfo.file.type);
          if (
            uploadInfo.file.type === "image/jpeg" ||
            uploadInfo.file.type === "image/png" ||
            uploadInfo.file.type === "image/jpg"
          ) {
            // 开启文件上传
            that.startImgUploadFlag = false;
          } else {
            // 文件类型不对按钮禁用
            that.$message.error(
              "仅支持PNG、JPG图片文件: " + uploadInfo.file.type
            );
          }
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          let fileExt = uploadInfo.file.name.split(".");
          fileExt = fileExt[fileExt.length - 1];
          // 不管 videoId 存不存在 都获取凭证
          let params = {
            title: that.add_info.title,
            fileExt: fileExt,
          };
          that.$api
            .get("/content/upload/image/auth.json", params)
            .then(
              (success) => {
                // 保存结果
                that.imgResult = success.data;
                console.log("sdage", success.data);
                //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                let uploadAuth = success.data.uploadAuth;
                let imageId = success.data.imageId;
                let uploadAddress = success.data.uploadAddress;
                img_uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  uploadAuth,
                  uploadAddress,
                  imageId
                );
              },
              (error) => {
                that.$message.error(error.msg);
              }
            )
            .catch((err) => {
              that.$message.error("凭证获取异常！");
            });
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // that.$message.error("上传成功！");
          that.$message({
            message: "上传成功!",
            type: "success",
          });
          // 把文件对象置空  上传对象置空
          that.img_uploader = null;
          that.img_file = null;
          console.log(
            "onUploadSucceed: " +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log(
            "onUploadFailed: file:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
        },
        // 文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          let progress = Math.ceil(loadedPercent * 100);
          that.imgProgress = progress;
          console.log(
            "onUploadProgress:file:" +
              uploadInfo.file.name +
              ", fileSize:" +
              totalSize +
              ", percent:" +
              Math.ceil(loadedPercent * 100) +
              "%"
          );
        },

        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("onUploadEnd: uploaded all the files");
        },
      });
      return img_uploader;
    },
    // 点击图片上传
    addImgUpload() {
      if (!this.add_info.cid) {
        return this.$message.error("请先选择章节！");
      }
      if (!this.img_file) {
        return this.$message.error("请先选择图片文件！");
      }
      // 1M 已经很大了 500KB吧
      if (this.img_file.size > 548576) {
        return this.$message.error("请控制图片尺寸在500KB以下！");
      }
      // 上传对象存在调用 startUpload 方法, 开始上传
      if (this.img_uploader !== null) {
        this.img_uploader.startUpload();
      }
    },
    coverImgUpload() {
      if (!this.add_info.cid) {
        return this.$message.error("请先选择章节！");
      }
      if (!this.cover_file) {
        return this.$message.error("请先选择图片文件！");
      }
      // 1M 已经很大了 500KB吧
      if (this.cover_file.size > 548576) {
        return this.$message.error("请控制图片尺寸在500KB以下！");
      }
      console.log(this.cover_file);
      // //  格式化文件数据
      let form = new FormData();
      form.append("file", this.cover_file);
      let res = this.$api.post("/content/image/upload.json", form);
      res.then((success) => {
            // 成功才会有数据
            this.$message({
              message: "上传成功！",
              type: "success",
            });
            this.add_info.coverUrl = success.data;
          },
          (err) => {
            this.$message.error(err.msg);
          }
        ).catch((err) => {
          console.log(err);
          this.$message.error("上传异常！");
        });
    },
    // 图片上传结束----------------------------------------

    // 2022-10-13 视频更新方法修改
    uploadStart() {
      this.$refs.addVideos.uploadStart();
    },
    uploadEnd() {
      setTimeout(() => {
        location.reload(); // 刷新
      }, 2500);
    }
  },
};
</script>

<style scoped>
/*表单内容布局 */
.el-main {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.el-input,
.el-select,
.el-textarea {
  width: 300px !important;
}

/* 视频 图片样式*/

/*.upload-container:hover {*/
/*border: 1px solid #409EFF;*/
/*}*/

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.video-container {
  width: 380px;
}

p {
  font-size: 10px;
  line-height: initial;
  color: #3939ff;
}

.voucher {
  display: inline-block;
  margin-left: 5px;
  color: #8c939d;
  border-bottom: #8c939d 1px solid;
  line-height: 20px;
  cursor: pointer;
}

.voucher:hover {
  border-bottom: #409eff 1px solid;
  color: #409eff;
}

/* 视频图片样式结束*/

.submit-btn {
  display: flex;
  justify-content: center;
}

/*!*上传进度条 */
.progress {
  font-size: 14px;
}

.progress i {
  font-style: normal;
}

/*本地图片预览*/
.local-img {
  width: 400px;
}

/*视频播放*/
.video {
  width: 400px;
  height: 300px;
}

.cover-img {
  width: 400px;
  height: 266px;
}
.video-upload-con {
  width: 100%;
  padding-left: 1.5rem;
}
.video-upload {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/practiceManage/AddContent.vue